<footer class="footer">
    <div class="w-100 clearfix">
    <span class="text-muted d-block text-center text-sm-left d-sm-inline-block">Copyright © 2021 <a href="https://brittaniaconsultancy.com/it-consultants/" target="_blank">Brittania Consultancy Services Ltd</a>. All rights reserved.</span>
    <!-- <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center"> <a href="http://www.ophantompro.co.uk/privacy.php" target="_blank">Privacy Policy</a> <i class="icon-heart text-danger"></i></span> -->
    </div>
</footer>
